export enum FormNameEnum {
  file = 'file',
  isAccessibleToStudents = 'isAccessibleToStudents',
  hasUploadPermissions = 'hasUploadPermissions',
  displayName = 'displayName',
  keyTerms = 'keyTerms',
  programs = 'programs',
  sessions = 'sessions',
  pillars = 'pillars',
  competencies = 'competencies',
  gradeLevels = 'gradeLevels',
  skillsAndBehaviors = 'skillsAndBehaviors',
  languages = 'languages',
  briefDescription = 'briefDescription',
  learningObjectives = 'learningObjectives',
  accessExpirationDate = 'accessExpirationDate',
  fileType = 'fileType',
  knowledgeSkillsAndAbilities = 'knowledgeSkillsAndAbilities',
  shouldDisableFileType = 'shouldDisableFileType',
  webLink = 'webLink',
  time = 'time',
  expirationDate = 'expirationDate',

  id = 'id',

  slideNumber = 'slideNumber',
  sessionThemeNumber = 'sessionThemeNumber',

  associatedResources = 'associatedResources',
  fileName = 'fileName',
  link = 'link',

  numberOfResources = 'numberOfResources',
  resourceIds = 'resourceIds',

  characterTraits = 'characterTraits',
  behavioralIndicators = 'behavioralIndicators',
  videoTranscriptionLink = 'videoTranscriptionLink',
  credentialing = 'credentialing',
  permissionInPerpetuity = 'permissionInPerpetuity',
  accessibilityStatus = 'accessibilityStatus',
  accessibilityReports = 'accessibilityReports',

  stockImageLinkNumber = 'stockImageLinkNumber',
  permissionNeeded = 'permissionNeeded',
  imageSources = 'imageSources',
  ethnicities = 'ethnicities',
  genders = 'genders',
  publishedOutputTool = 'publishedOutputTool',
  alternateText = 'alternateText',
  linkToStockImageSource = 'linkToStockImageSource',

  urlSource = 'urlSource',
  usageType = 'usageType',
  reuseFlag = 'reuseFlag',
  notes = 'notes',
  permissionAgreementUrl = 'permissionAgreementUrl',
}
